module.exports = __webpack_public_path__ + "static/media/resumePDF.40d505a5.pdf";